import React, {Component} from 'react';
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import {Table, message, Col, Button} from 'antd';
import {shippingCostService} from "../../services/otodisApi/ShippingCostService";
import {PlusSquareOutlined} from "@ant-design/icons";
import {ShippingCostStates} from "./types/ShippingCostTypes";
import withAuth from "../../hoc/withAuth";
import currencyFormat from "../../helper/currencyFormat";

export interface ShippingCostProps {
}

class ShippingCost extends Component<ShippingCostProps & any, ShippingCostStates> {
    private readonly initState!: ShippingCostStates;
    private tableColumn: any = [
        {
            title: 'Kode Kota',
            dataIndex: 'city_code',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{value}</span>
            })
        },
        {
            title: 'Nama Kota',
            dataIndex: 'city_name',
            render: (value: string) => {
                return <span className={`font-90`}>{value}</span>
            }
        },
        {
            title: 'PELWIL',
            dataIndex: 'pelwil',
            render: (value: string) => {
                return <span className={`font-90`}>{currencyFormat(Number(value))}</span>
            }
        },
        {
            title: 'PDI',
            dataIndex: 'pdi',
            render: (value: string) => {
                return <span className={`font-90`}>{currencyFormat(Number(value))}</span>
            }
        },
        {
            title: 'BPKON',
            dataIndex: 'bpkon',
            render: (value: string) => {
                return <span className={`font-90`}>{currencyFormat(Number(value))}</span>
            }
        },
        {
            title: 'BPDEAD',
            dataIndex: 'bpdead',
            render: (value: string) => {
                return <span className={`font-90`}>{currencyFormat(Number(value))}</span>
            }
        },
        {
            title: 'BPDEAB',
            dataIndex: 'bpdeab',
            render: (value: string) => {
                return <span className={`font-90`}>{currencyFormat(Number(value))}</span>
            }
        },
        {
            title: 'BIAYA BIRO JASA',
            dataIndex: 'bureau_fee',
            render: (value: string) => {
                return <span className={`font-90`}>{currencyFormat(Number(value))}</span>
            }
        },
        {
            title: 'TOL',
            dataIndex: 'tol',
            render: (value: string) => {
                return <span className={`font-90`}>{currencyFormat(Number(value))}</span>
            }
        },
    ]

    constructor(props: ShippingCostProps & any | any) {
        super(props);

        this.initState = {
            processing: false,
            processingFetchTableData: true,
            dealerCode: props.match.params.dealerCode.replace(/-/g, '#'),
            dataConfig: [],
            pageSize: 500,
            modalAddWarehouse: false,
            addProcessing: false,
        }
        this.state = {...this.initState}
    }

    onDealerChange = async (data: any) => {
        await this.promisedSetState({
            processingFetchTableData: true,
            dealerCode: data.value,
        });

        await this.fetchStockData();
    }

    fetchStockData = async () => {
        shippingCostService.getData({
            dealerCode: this.state.dealerCode
        }).then((dataFetchWarehouse) => {
            this.setState({
                dealerCode: this.state.dealerCode,
                dataConfig: dataFetchWarehouse.data.data,
                processingFetchTableData: false,
            });
        }).catch(async (e) => {
            await this.promisedSetState({
                dataConfig: [],
                processingFetchTableData: false,
            });
            message.error('Data Tidak Ditemukan');
        })
    }

    onChangeTable = (pagination: any, filters: any, sorter: any) => {
        if (pagination?.pageSize) {
            this.setState({
                pageSize: pagination?.pageSize,
            });
        }
    }

    async componentDidMount() {
        await this.fetchStockData();
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <MainLayout noPadNoMar={true} onChangeDealer={this.onDealerChange} breadcrumbPath={`Setting`} breadcrumbMenu={`Biaya Tujuan`} defaultSelectedKeys={['m-setting-shipping']} defaultOpenKeys={['sm-setting']}>

                    <Col span={24} className={`pad-10`}>
                        <a href={`/${this.state.dealerCode.replace(/#/g, '-')}/add-shipping-cost`}>
                            <Button type={'primary'}
                                    icon={<PlusSquareOutlined/>}
                            >Tambah / Update Data</Button>
                        </a>
                    </Col>

                    <Table
                        rowKey={'warehouse_code'}
                        size={'small'}
                        scroll={{x: 'calc(500px + 50%)'}}
                        loading={this.state.processingFetchTableData}
                        columns={this.tableColumn}
                        dataSource={this.state.dataConfig}
                        pagination={{pageSize: this.state.pageSize}}
                        onChange={this.onChangeTable}
                    />
                </MainLayout>
            </React.Fragment>
        );
    }
}

export default (withAuth(withRouter(ShippingCost), 27));
